"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalErrorHandlerPlugin = exports.GlobalErrorAction = void 0;
const plugin_1 = require("../plugin");
var GlobalErrorAction;
(function (GlobalErrorAction) {
    GlobalErrorAction[GlobalErrorAction["TerminateApplication"] = 0] = "TerminateApplication";
    GlobalErrorAction[GlobalErrorAction["Ignore"] = 1] = "Ignore";
})(GlobalErrorAction = exports.GlobalErrorAction || (exports.GlobalErrorAction = {}));
/**
 * This plugin is responsible for catching global errors that have not been handled,
 * and determining whether to kill the application or not.
 */
let GlobalErrorHandlerPlugin = class GlobalErrorHandlerPlugin extends plugin_1.BasePlugin {
    install(ctx, config) {
        if (ctx.platform !== "node")
            throw new Error("This plugin is only usable in a Node environment");
        this.onUncaughtException = async (err) => {
            ctx.logger.error("Uncaught error", err);
            if ((config === null || config === void 0 ? void 0 : config.errorFilter) && config.errorFilter(err) === GlobalErrorAction.Ignore) {
                return;
            }
            await ctx.exitApplication();
            process.exit(1);
        };
        this.onUnhandledRejection = (err) => {
            throw err;
        };
        process.on("uncaughtException", this.onUncaughtException);
        process.on("unhandledRejection", this.onUnhandledRejection);
    }
    async beforeApplicationExit(hook) {
        await super.beforeApplicationExit(hook);
        process.off("uncaughtException", this.onUncaughtException);
        process.off("unhandledRejection", this.onUnhandledRejection);
    }
};
GlobalErrorHandlerPlugin = __decorate([
    plugin_1.Plugin()
], GlobalErrorHandlerPlugin);
exports.GlobalErrorHandlerPlugin = GlobalErrorHandlerPlugin;
//# sourceMappingURL=plugin.js.map